import React from 'react';
import TryThisOut from '../../pages/tryNow/TryThisOut';

function MalaysianVoterIdOCR({ currentProduct }) {
  return (
    <>
      <TryThisOut currentProduct={currentProduct} />
    </>
  );
}

export default MalaysianVoterIdOCR;
